import { App, Button, Flex, Popconfirm, Space, Typography } from 'antd'
import { images } from 'assets'
import { Modal } from 'antd' // Import Ant Design's Modal
import useScopes from 'hooks/useScopes'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'
import { MdLogout } from 'react-icons/md'
import { NotificationManager } from 'react-notifications'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { actions } from 'slices/app.slice'
import {
  addCurrentSession,
  addEngagedPatient,
  addInboxMessages,
  addPatientData,
  showCloseChatTag,
} from 'slices/mentalHealth.slice'
import { manageCall } from 'slices/manageCall.slice'

import { removeCurrentSession } from 'slices/selectedPatient.slice'
import { update, ref } from 'firebase/database'
import { database } from 'utils/firebase'
import { addDoctorLog } from 'utils/functions'
import dayjs from 'dayjs'

const TopBar = () => {
  const navigate = useNavigate()
  const { message, notification } = App.useApp()
  const location = useLocation()
  const { me: user } = useSelector((state) => state.app)
  const { closeChatData, currentSession, engagedData } = useSelector(
    (state) => state.mentalHealth,
  )
  const { manageCallData } = useSelector((state) => state.callData)
  const { userTimeZone, userTimeZoneName } = useSelector((state) => state.timeZone)
  const [lowTimeNotificationSent, setLowTimeNotificationSent] = useState(false)
  const [finishNotificationSent, setFinishNotificationSent] = useState(false)
  const [currentDateTime, setCurrentDateTime] = useState({
    time: dayjs().tz(userTimeZone || "UTC").format('hh:mm A'),
    date: dayjs().tz(userTimeZone || "UTC").format('MMM DD, YYYY')
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime({
        time: dayjs().tz(userTimeZone || "UTC").format('hh:mm A'),
        date: dayjs().tz(userTimeZone || "UTC").format('MMM DD, YYYY')
      });
    }, 1000); // Update every second

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [userTimeZone]);


  useEffect(() => {
    if (closeChatData) {
      const remainingTime = closeChatData?.time
      const timeFinished = closeChatData?.timeFinish

      // Notify when the remaining time is under a threshold (e.g., 10 minutes) if not already sent
      if (remainingTime && remainingTime <= 10 && !lowTimeNotificationSent) {
        sendNotification('The session will end in 10 minutes. Please wrap up.')
        setLowTimeNotificationSent(true)
      }

      // Notify when the session has finished
      if (timeFinished && !finishNotificationSent) {
        // sendNotification('The session has ended. Please close the chat.')
        setFinishNotificationSent(true)
      }
    }
  }, [closeChatData, lowTimeNotificationSent, finishNotificationSent])

  // Function to send notification to the user (in this case, can be a browser notification)
  const sendNotification = (message) => {
    NotificationManager.success(message, 'Session End Reminder', 5000)
  }
  const { isAdmin } = useScopes()
  const dispatch = useDispatch()
  // Retrieve the cookie value
  const getCookie = (cookieName) => {
    return Cookies.get(cookieName)
  }
  const handleLogout = async () => {
    try {
      Modal.confirm({
        title: 'Confirm Logout',
        content: 'Are you sure you want to log out?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: async () => {
          console.log('log out calling in topBar.js');

          try {
            if (isAdmin) {
              dispatch(addCurrentSession(null))
              const obj = { engageCall: false }
              dispatch(manageCall(obj))
              dispatch(addEngagedPatient(null))
              dispatch(showCloseChatTag(false))
              dispatch(removeCurrentSession())
              dispatch(addPatientData(null))
              dispatch(addInboxMessages([]))
              const updates = {
                [`doctors/${user.id}/online`]: false,
                [`doctors/${user.id}/accepting_chat`]: false,
              }
              console.log('log out calling in topBar.js isAdmin')
              if (user?.accepting_chat) {
                await addDoctorLog({
                  action: 'ACCEPTING_CHAT_OFF',
                  category: 'session',
                  doctorID: user.id,
                  description: 'Doctor turned off accepting chat',
                  details: {
                    timestamp: Date.now()
                  }
                })
              }
              await addDoctorLog({
                action: 'LOGOUT',
                category: 'session',
                doctorID: user.id,
                description: 'Doctor logged out',
                details: {
                  timestamp: Date.now()
                }
              })

              await update(ref(database), updates)
              dispatch(actions.logout())
            } else {
              if (engagedData && !engagedData.inbox) {
                notification.info({
                  message: 'Please close the chat before logout',
                  duration: 5,
                })
                return
              }

              if (manageCallData?.engageCall) {
                notification.info({
                  message: 'Please close your engage call before logout',
                  duration: 5,
                })
                return
              }

              console.log('log out calling in topBar.js isAdmin not')

              try {
                const COOKIE_KEY = 'userUUID'
                const UUID = getCookie(COOKIE_KEY)
                console.log('Deleted')

                const updates = {}
                updates[`/doctors/${user.id}/notificationTokens/PHD`] =
                  null
                await update(ref(database), updates);
                console.log('FCM token Deleted in Firebase.')
              } catch (error) {
                console.error('Error Deleted FCM token in Firebase:', error)
              }

              dispatch(addCurrentSession(null))
              const obj = { engageCall: false }
              dispatch(manageCall(obj))
              dispatch(addEngagedPatient(null))
              dispatch(showCloseChatTag(false))
              dispatch(removeCurrentSession())
              dispatch(addPatientData(null))
              dispatch(addInboxMessages([]))

              const updates = {
                [`doctors/${user.id}/online`]: false,
                [`doctors/${user.id}/accepting_chat`]: false,
              }
              if (user?.accepting_chat) {
                await addDoctorLog({
                  action: 'ACCEPTING_CHAT_OFF',
                  category: 'session',
                  doctorID: user.id,
                  description: 'Doctor turned off accepting chat',
                  details: {
                    timestamp: Date.now()
                  }
                })
              }
              await addDoctorLog({
                action: 'LOGOUT',
                category: 'session',
                doctorID: user.id,
                description: 'Doctor logged out',
                details: {
                  timestamp: Date.now()
                }
              })
              await update(ref(database), updates);

              dispatch(actions.logout())

            }
          } catch (error) {
            console.error('Error during logout:', error);
          } finally {
            // Ensure the modal is closed after logout
            Modal.destroyAll();
          }
        },
        onCancel: () => {
          console.log('Logout cancelled');
        },
      });
    } catch (error) {
      console.error(error)
    }
  };


  return (
    // <div className="d-flex justify-content-between align-items-center mb-3 ">
    //   <img
    //     src={images.logo}
    //     alt="logo"
    //     className="p-2 rounded-circle"
    //     style={{
    //       height: '65px',
    //       background: 'white',
    //       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    //     }}
    //   />
    //   <Typography.Text strong>{user.doctorName || ''}</Typography.Text>
    //   <Flex gap={5}>
    //     {isAdmin && location.pathname === '/home' && (
    //       <Typography.Text
    //         strong
    //         underline
    //         style={{ color: '#727272', cursor: 'pointer' }}
    //         onClick={() => navigate('/admin-dashboard')}
    //       >
    //         Switch to Counselor
    //       </Typography.Text>
    //     )}
    //     {isAdmin && location.pathname === '/admin-dashboard' && (
    //       <Typography.Text
    //         strong
    //         underline
    //         style={{ color: '#727272', cursor: 'pointer' }}
    //         onClick={() => navigate('/home')}
    //       >
    //         Switch to GP
    //       </Typography.Text>
    //     )}

    //     <Space
    //       style={{ cursor: 'pointer' }}
    //       onClick={() => dispatch(actions.logout())}
    //     >
    //       <MdLogout size={25} color="#df7467" alt="log out" />
    //       <Typography.Text strong>Logout</Typography.Text>
    //     </Space>
    //   </Flex>
    // </div>
    <div
      className="d-flex justify-content-between align-items-center mb-3"
      style={{ flexDirection: 'column', textAlign: 'center' }}
    >
      <div className="d-flex justify-content-between align-items-center w-100 ">
        <img
          src={images.logo}
          alt="logo"
          className="p-2 rounded-circle"
          style={{
            height: '65px',
            background: 'white',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
        />

        <Typography.Text strong>
          {user.doctorName || 'Counsellor Staging'}
        </Typography.Text>

        <Flex gap={5}>
          {isAdmin && location.pathname === '/home' && (
            <Typography.Text
              strong
              underline
              style={{ color: '#727272', cursor: 'pointer' }}
              onClick={() => navigate('/admin-dashboard')}
            >
              Switch to Provider
            </Typography.Text>
          )}
          {isAdmin && location.pathname === '/admin-dashboard' && (
            <Typography.Text className="d-flex justify-content-between align-items-center w-100"
              strong
              underline
              style={{ color: '#727272', cursor: 'pointer' }}
              onClick={() => navigate('/home')}
            >
              Switch to GP
            </Typography.Text>
          )}
          {/* engageCall show popiconfrim else show a simple button */}
          {/* {!isAdmin && manageCallData?.engageCall ? (
            <Popconfirm
              title="Please close your engage call before logout"
              onConfirm={() => {}}
              okText="Ok"
              cancelText="Cancel"
            >
              <Button
                style={{ cursor: 'pointer', outline: 'none', border: 'none' }}
              >
                <MdLogout size={25} color="#df7467" alt="log out" />
                <Typography.Text strong>Logout</Typography.Text>
              </Button>
            </Popconfirm>
          ) : ( */}
          <div className="d-flex justify-content-between align-items-center w-100" style={{ color: '#DF7467', fontWeight: 'bold' }}>
            {userTimeZoneName || "UTC"} - {currentDateTime.date} {currentDateTime.time}
          </div>
          <Button
            style={{ cursor: 'pointer', outline: 'none', border: 'none' }}
            onClick={handleLogout}
          >
            <MdLogout size={25} color="#df7467" alt="log out" />
            <Typography.Text strong>Logout</Typography.Text>
          </Button>
          {/* )} */}
        </Flex>
      </div>

      {closeChatData?.showTag &&
        closeChatData?.counselorID === user?.id &&
        !currentSession?.inbox && (
          <span
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'Source Sans Pro',
              fontWeight: 400,
              fontSize: '16px',
              color: '#FFFFFF',
              backgroundColor: '#DE3333',
              padding: '3px 25px',
              borderRadius: '5px',
              // width: '70%',
              // padding: '3px 30px',

            }}
          >
            {closeChatData?.timeFinish
              ? `Session time is completed Kindly close this sessions!`
              : `The remaining time for this session is ${closeChatData?.time}mins. Kindly wrap up this session and close it!`}
          </span>
        )}
    </div>
  )
}

export default TopBar
